import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import logo from "../../../assets/images/logo2.png";
import Menus from "./menus";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { setLanguage } from "react-multi-lang";
import "./style.scss";
import { scrollToTopSmooth } from "../../../util";
import { Button } from "reactstrap";
import { LineArrow } from "../../SvgComponents";
import globalConfig from "../../../globalConfig";

function MenuIcon() {
  return (
    <svg
      fill="#fff"
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="menu"
      width="1em"
      height="1em"
      aria-hidden="true"
    >
      <path d="M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"></path>
    </svg>
  );
}

function Header() {
  const [isSticky, setIsSticky] = useState(false);
  const [menu, setMenu] = useState(false);
  const storeData = useSelector((store) => store);

  // Optimized scroll handler with throttling
  const handleScroll = useCallback(() => {
    const scrollY = window.scrollY;
    setIsSticky(scrollY > 70);
  }, []);

  useEffect(() => {
    // Simple throttled scroll handler
    let timeoutId = null;
    const throttledHandleScroll = () => {
      if (timeoutId === null) {
        timeoutId = setTimeout(() => {
          handleScroll();
          timeoutId = null;
        }, 100);
      }
    };

    window.addEventListener("scroll", throttledHandleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", throttledHandleScroll);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [handleScroll]);

  const history = useHistory();

  const menuData = [
    {
      name: "HOME",
      link: window.location.href.includes("hos-postcards")
        ? "/hos-postcards"
        : "/",
    },  {
      name: "DESTINATIONS",
      link:  "/view-all-destination",
    },
    // { name: "DESTINATIONS", link: "/view-all-destination" },

    {
      name: "EVENTS",
      link: "https://discovershurooq.ae/events",
    },
   // { name: "DINING", link: "https://discovershurooq.ae/F&B" },

    // { name: "ABOUT ", link: window.location.href.includes("hos-postcards") ? "/hos-postcards-about" : "/aboutus" },
    // { name: "CONTACT", link: window.location.href.includes("hos-postcards") ? "/hos-postcards-contact" : "/contactus" },
    // { name: `CART`, link: "/cart" },
    // { name: "STORES", link: "/stores" },
  ];

  // Initialize language on mount - no jQuery
  useEffect(() => {
    const lang = localStorage.getItem("user_language") || "en";
    const htmlElement = document.documentElement;

    if (lang === null || lang === "en") {
      localStorage.setItem("user_language", "en");
      setLanguage("en");
      htmlElement.setAttribute("dir", "ltr");
      htmlElement.setAttribute("lang", "en");
    } else if (lang === "ae") {
      setLanguage("ar");
      htmlElement.setAttribute("lang", "ar");
      htmlElement.setAttribute("dir", "rtl");
    }
  }, []);

  const noOfQuantity = useCallback(() => {
    const cart = JSON.parse(localStorage.getItem("products") || "[]");
    return cart.reduce((total, product) => total + (product.qty || 0), 0);
  }, []);

  const cartQuantity = noOfQuantity();

  return (
    <>
      {!globalConfig.isStorePage && (
        <header
          id="header"
          className={isSticky ? "header-sticky" : ""}
          style={{
            backgroundColor: isSticky ? "#000000b3" : "transparent",
          }}
        >
          <Container fluid="xl">
            <div className="logo">
              <Link to="/" onClick={scrollToTopSmooth}>
                <img src={logo} height="100px" alt="logo" />
              </Link>
            </div>
            <Menus
              active={menu}
              close={() => setMenu(false)}
              menuData={menuData}
            />
            <div
              className="links"
              style={{ display: "flex", alignItems: "center" }}
            >
              {cartQuantity > 0 && (
                <Link
                  to={`/stores/gsharshop/cart`}
                  style={{ fontSize: "20px" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    fill="currentColor"
                    className="bi bi-cart4"
                    viewBox="0 0 16 16"
                  >
                    <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l.5 2H5V5H3.14zM6 5v2h2V5H6zm3 0v2h2V5H9zm3 0v2h1.36l.5-2H12zm1.11 3H12v2h.61l.5-2zM11 8H9v2h2V8zM8 8H6v2h2V8zM5 8H3.89l.5 2H5V8zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" />
                  </svg>
                  {/* <i className="fa fa-shopping-cart" aria-hidden="true"></i> */}
                  <span className="badge badge-warning" id="lblCartCount">
                    {cartQuantity}
                  </span>
                </Link>
              )}
              {/* {storeData.user.token ? null : (
                <Link
                  to="/register"
                  onClick={scrollToTopSmooth}
                  style={{ marginTop: 5 }}
                >
                  Register
                </Link>
              )} */}
              {/* {storeData.user.token ? null : <Button color="" className="arrow" onClick={() => history.push(`/register`)}>
            <span>
              Register
              <LineArrow />
            </span>
          </Button>} */}
              {storeData.user.token ? (
                // <Link to="/settings" onClick={scrollToTopSmooth} className="btn btn-primary">
                //   My Account
                // </Link>
                <Button
                  color="primary"
                  style={{ width: 140 }}
                  className="arrow"
                  onClick={() => history.push(`/settings`)}
                >
                  <span>
                    My Account
                    <LineArrow />
                  </span>
                </Button>
              ) : (
                // <Link to="/login" onClick={scrollToTopSmooth} className="btn btn-primary">
                //   Sign in
                // </Link>
                <Button
                  color="primary"
                  style={{ width: 100 }}
                  className="arrow"
                  onClick={() => history.push(`/login`)}
                >
                  <span>
                    Sign in
                    <LineArrow />
                  </span>
                </Button>
              )}

              <button
                onClick={() => setMenu(true)}
                className="menu-btn d-lg-none"
              >
                <MenuIcon />
              </button>
            </div>
          </Container>
        </header>
      )}
    </>
  );
}
export default Header;
